import { Button, Text } from '@change/ds-core-ui';
import { SearchIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core-react/i18n';

import { useNoResultsScreen } from './hooks/useNoResultsScreen';

export const NoResultsScreen: React.FC = () => {
	const {
		data: { query, disableClearFilters },
		actions: { clearFilters },
	} = useNoResultsScreen();

	return (
		<div className="border-stroke-weaker mt-4 flex flex-col items-center justify-center overflow-hidden rounded-sm border border-solid px-4 pt-10 pb-20">
			<SearchIcon gradient size="x-large" />
			<Text as="h3" variant="heading" size="small" className="mt-8 text-center" data-qa="no-results-heading">
				<Translate value="corgi.search.error.no_results.title" />
			</Text>
			<Text as="p" variant="body" className="mt-5 text-center wrap-break-word">
				{query === '*' || !query ? (
					<Translate value="corgi.search.error.no_results.subtitle_no_query" />
				) : (
					<Translate
						value="corgi.search.error.no_results.subtitle"
						replacements={{
							query,
						}}
					/>
				)}
			</Text>
			<Text as="p" variant="body" className="text-typography-weak mt-2 text-center">
				<Translate value="corgi.search.error.no_results.cta_message" />
			</Text>
			<div className="mt-5 flex justify-center gap-3">
				<Button
					variant="secondary"
					size="small"
					disabled={disableClearFilters}
					onClick={clearFilters}
					data-qa="no-results-clear-filters-button"
				>
					<Translate value="corgi.search.filters.clear_filters.title" />
				</Button>
				<Button
					as="a"
					href="/start-a-petition/intro?source_location=search_page_no_results"
					size="small"
					variant="primary"
					className="no-underline"
					data-qa="no-results-sap-cta"
				>
					<Translate value="corgi.search.error.no_results.cta_sap" />
				</Button>
			</div>
		</div>
	);
};
